<form class="app-flex-form" (click)="debugForm(constructor.name)" (keydown)="(null)">
  @for (filter of filters(); track $index) {
    @if (currentFilterView() === filter.label && filter.column === subscriptionAdminFilterKey.Status) {
      <mat-selection-list [formField]="formTree.status">
        @for (status of subscriptionStatusValues; track $index) {
          <mat-list-option [value]="status" (click)="$event.stopPropagation()">
            {{ status | subscriptionStatusDisplay }}
          </mat-list-option>
        }
      </mat-selection-list>
    }
  }
</form>
